import { IGardeCalendarDate, IGardeModel, IMonthCustody } from '../interfaces/garde.interface';
import { IUser } from '../interfaces/users/user.interface';
import {
    getFirstDayOfNextSchoolYear, getFirstDayOfSchoolYear,
    getLastDayOfMonth, isDate1BeforeDate2
} from './date.utils';

export const getCustodyByDay = (date: any, selectedMonthCustody: IMonthCustody): IGardeCalendarDate => {
    let currentCustody: IGardeCalendarDate = null;
    const calendarDate: Date = new Date(date.setHours(12));
    if (selectedMonthCustody) {
        currentCustody = selectedMonthCustody.custody.find((custody: IGardeCalendarDate) => {
            if (typeof custody.date === 'string') {
                return new Date(custody.date).getTime() === calendarDate.getTime();
            }
            return new Date(custody.date.setHours(12)).getTime() === calendarDate.getTime();
        });
    }
    return currentCustody;
};
export const custodyModels: IGardeModel[] = [
    {
        id: 1,
        name: '7-7',
        pattern: [
            [1, 1, 1, 1, 1, 2, 2],
            [2, 2, 2, 2, 2, 1, 1],
            [1, 1, 1, 1, 1, 2, 2],
            [2, 2, 2, 2, 2, 1, 1],
        ],
        tips: 'GARDES.TIPS1',
    },
    {
        id: 2,
        name: '12-2',
        pattern: [
            [1, 1, 1, 1, 1, 1, 1],
            [1, 1, 1, 1, 1, 2, 2],
            [1, 1, 1, 1, 1, 1, 1],
            [1, 1, 1, 1, 1, 2, 2],
        ],
        tips: 'GARDES.TIPS2',
    },
    {
        id: 3,
        name: '3-3-4-4',
        pattern: [
            [1, 1, 1, 2, 2, 2, 1],
            [1, 1, 1, 2, 2, 2, 2],
            [1, 1, 1, 2, 2, 2, 1],
            [1, 1, 1, 2, 2, 2, 2],
        ],
        tips: 'GARDES.TIPS3',
    },
    {
        id: 5,
        name: '2-2-5-5',
        pattern: [
            [1, 1, 2, 2, 1, 1, 1],
            [1, 1, 2, 2, 2, 2, 2],
            [1, 1, 2, 2, 1, 1, 1],
            [1, 1, 2, 2, 2, 2, 2],
        ],
        tips: 'GARDES.TIPS5',
    },
    {
        id: 6,
        name: '2-2-3',
        pattern: [
            [1, 1, 2, 2, 1, 1, 1],
            [2, 2, 1, 1, 2, 2, 2],
            [1, 1, 2, 2, 1, 1, 1],
            [2, 2, 1, 1, 2, 2, 2],
        ],
        tips: 'GARDES.TIPS6',
    },
];

/**
 * Apply Custody Model
 *
 * @param custodyModelId to apply
 * @param parents
 * @param selectedParentId
 * @param start - optional start date
 * @param end - optional end date
 */
export const applyCustodyModel = (
    custodyModelId: number,
    parents: IUser[],
    selectedParentId: number,
    start?: Date,
    end?: Date
): IGardeCalendarDate[] => {
    const currentModel: IGardeModel = custodyModels.find((model: IGardeModel) => model.id === custodyModelId);
    if (!currentModel) {
        return [];
    }
    const startDate: Date = start ? new Date(start) : getFirstDayOfSchoolYear();
    const currentDate: Date = new Date(startDate);
    currentDate.setHours(12, 0, 0, 0);
    const endDate: Date = end ? new Date(end) : (start ? getLastDayOfMonth(startDate) : getFirstDayOfNextSchoolYear());

    let day: number = currentDate.getDay();
    let month: number = currentDate.getMonth();
    let week: number = 0;

    let custodyData: IGardeCalendarDate[] = [];

    while (isDate1BeforeDate2(currentDate, endDate)) {
        day = currentDate.getDay();
        if (day === 0) day = 6;
        else day -= 1;

        const parent: IUser =
            currentModel.pattern[week][day] === 1 && selectedParentId === parents[0].id
                ? parents[0]
                : currentModel.pattern[week][day] === 2 && selectedParentId !== parents[0].id
                ? parents[0]
                : parents[1];
        custodyData = [
            ...custodyData,
            {
                date: new Date(currentDate),
                parent_id: parent.id,
                firstname: parent.firstname,
                colorClass: selectedParentId === parent.id ? ' -blue' : ' -pink',
            },
        ];

        // next step -> while()
        // nouvelle semaine
        if (currentDate.getDay() === 0) {
            if (week + 1 === currentModel.pattern.length) {
                week = 0;
            } else {
                week += 1;
            }
        }
        currentDate.setDate(currentDate.getDate() + 1);
        // nouveau mois
        if (currentDate.getMonth() !== month) {
            month += 1;
            if (month === 12) {
                month = 0;
            }
        }
    }
    return custodyData;
};
